import tinycolor from "tinycolor2";
import { brand } from "../context";

export const easyColors = {
  orange: "#FF6600",
  lightOrange: tinycolor("#FF6600").lighten(10).toHexString(),
  lightOrange2: tinycolor("#FF6600").lighten(15).toHexString(),
  lightOrange3: tinycolor("#FF6600").lighten(40).toHexString(),
  lightOrange4: tinycolor("#FF6600").lighten(45).toHexString(),
  creme: "#F8E9DD",
};

const rocsColors = {
  base_color_red: "#D90F16",
};

const base_color_table = {
  easy: easyColors.orange,
  default: "#28527a",
  mse: "#1FB1B5",
  isg: "#008cb2",
  cst: "#ADC1B9",
  mycarte: "#A33021",
  soulatravel: "#BB7B90",
  corporatetravelclub: "#F3A033",
  unionshopper: "#BE312D",
  tabula_rasa: "#000000",
  atlantic: "#4590F9",
  festival: "#8AB547",
  knoxtravel: "#184578",
  traveldealfinders: "#1F498B",
  tmdh: "#62BFC0",
  thehotelco: "black",
  clubseacret: "#b9a37a",
  infinite: "#14191A",
  rocs: "#333333",
  fightzone: "black",
  travellingtime: "#003a52",
  htg: "#00ABCB",
  fluturolire: "#003663",
  flymenow: "#ad8c8c",
  truecations: "#205476",
  oasis: "#fe7b0a",
  greecetrips: "#00A5CC",
  innstanttravel: "#FF9900",
  uab: "#0F314C",
  booknow: "#0b5079",
  maldives: "#da1f13",
  mytravellifestyle: "#005A64",
  miki: "#302A83",
  eko: "#D90130",
  helleniq: "#35C3F9",
  interamerican: "#D6001C",
  hgv: "#165C7D",
  kemet: "#4D3F24",
  travily: "#002D5D",
  clubwyndham: "#976E32",
  mts: "#04377C",
  accorvacationclub: "#58b6e7",
};

const secondary_color_table = {
  easy: easyColors.orange,
  default: "#28527a",
  mse: "#1FB1B5",
  isg: "#008cb2",
  cst: "#ADC1B9",
  mycarte: "#A33021",
  soulatravel: "#BB7B90",
  corporatetravelclub: "#F3A033",
  unionshopper: "#BE312D",
  tabula_rasa: "#000000",
  atlantic: "#4590F9",
  festival: "#8AB547",
  knoxtravel: "#184578",
  traveldealfinders: "#1F498B",
  tmdh: "#62BFC0",
  thehotelco: "black",
  clubseacret: "#b9a37a",
  infinite: "#9a9797",
  rocs: "#333333",
  fightzone: "black",
  travellingtime: "#003a52",
  htg: "#00ABCB",
  fluturolire: "#003663",
  flymenow: "#ad8c8c",
  truecations: "#205476",
  oasis: "#fe7b0a",
  greecetrips: "#00A5CC",
  innstanttravel: "#9A287A",
  uab: "#D7533B",
  hgv: "#00B0B9",
  mytravellifestyle: "#D90F16",
  kemet: "#FB9600",
  travily: "#857550",
  clubwyndham: "#976E32",
  mts: "#00A2D2",
  accorvacationclub: "#58b6e7",
};

function getBackgrounds() {
  switch (brand) {
    case "easy":
      return {
        dark: "black",
        darker: tinycolor("#F9F8FD").darken(5).toHexString(),
        light: "#F5F5F5",
        lightGray: "#F3F3F3",
        darkHover: tinycolor("#000000").lighten(20).toHexString(),
      };
    case "rocs":
      return {
        dark: "#333333",
        darker: tinycolor("#F9F8FD").darken(5).toHexString(),
        light: "#F9F8FD",
        lightGray: "#eaeaea",
        darkHover: tinycolor("#000000").lighten(20).toHexString(),
      };
    case "thehotelco":
      return {
        dark: "black",
        darker: tinycolor("#F9F8FD").darken(5).toHexString(),
        light: "white",
        lightGray: "#eaeaea",
        darkHover: tinycolor("#000000").lighten(20).toHexString(),
      };
    case "travellingtime":
      return {
        dark: "#003663",
        darker: tinycolor("#F9F8FD").darken(5).toHexString(),
        light: "white",
        lightGray: "#eaeaea",
        dark_red: "#6c0300",
        darkHover: tinycolor("#000000").lighten(20).toHexString(),
      };
    case "oasis":
      return {
        dark: "#3d3d3d",
        darker: tinycolor("#3d3d3d").darken(5).toHexString(),
        light: "#F9F8FD",
        lightGray: "#F3F3F3",
        darkHover: tinycolor("#000000").lighten(20).toHexString(),
      };
    case "innstanttravel":
      return {
        dark: "#2C3137",
        darker: tinycolor("#2C3137").darken(5).toHexString(),
        purple: secondary_color_table[brand],
        light: "#F5F5F5",
        lightGray: "#E9F0F4",
        darkHover: tinycolor("#000000").lighten(20).toHexString(),
      };
    default:
      return {
        dark: "black",
        darker: tinycolor("#F9F8FD").darken(5).toHexString(),
        light: "white",
        lightGray: "#eaeaea",
        darkHover: tinycolor("#000000").lighten(20).toHexString(),
      };
  }
}

export function getColors() {
  const commonAttrs = {
    base_color: base_color_table[brand],
    secondary_color: secondary_color_table[brand],
    border: "lightgray",
    tripadvisor: "#00AA6C",
    red: "#D90F16",
    background: getBackgrounds(),
    creme: easyColors.creme,
    stripe_color: "#DDC972",
  };

  switch (brand) {
    case "easy":
      return {
        ...commonAttrs,
        text: {
          dark: "black",
          light: "white",
          highlight: easyColors.orange,
        },
      };
    case "thehotelco":
      return {
        ...commonAttrs,
        pink: "#FA5590",
        text: { dark: "black", light: "white", highlight: easyColors.orange },
      };
    case "rocs":
      return {
        ...commonAttrs,
        red: rocsColors.base_color_red,
        text: {
          dark: tinycolor("black").lighten(20).toHexString(),
          light: "white",
          highlight: easyColors.orange,
        },
      };
    case "travellingtime":
      return {
        ...commonAttrs,
        text: { dark: "black", light: "white" },
      };
    case "flymenow":
      return {
        ...commonAttrs,
        text: { dark: "#1b1b1b", light: "white", highlight: "#b9a37a" },
      };
    case "oasis":
      return {
        ...commonAttrs,
        text: { dark: "black", light: "white", highlight: easyColors.orange },
      };
    case "clubwyndham":
      return {
        ...commonAttrs,
        text: { dark: "black", light: "white", highlight: "" },
      };
    case "accorvacationclub":
      return {
        ...commonAttrs,
        text: { dark: "black", light: "white", highlight: "" },
      };
    case "innstanttravel":
      return {
        ...commonAttrs,
        text: {
          dark: "black",
          light: "white",
          highlight: secondary_color_table[brand],
        },
      };
    case "mts":
      return {
        ...commonAttrs,
        text: {
          dark: "black",
          light: "white",
          highlight: secondary_color_table[brand],
        },
      };
    default:
      return {
        ...commonAttrs,
        text: {
          dark: tinycolor("black").lighten(20).toHexString(),
          light: "white",
          highlight: easyColors.orange,
        },
      };
  }
}
